import styled from 'styled-components';

export const ProductVerticalListDetailCardGroup = styled.div`
  display: flex;
  padding: 24px var(--radius-large, 16px) 32px var(--radius-large, 16px);
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;

  overflow: hidden;
`;
